import { ViewContainerRef } from '@angular/core';
import * as i0 from "@angular/core";
export let DynamicDialogContent = /*#__PURE__*/(() => {
  class DynamicDialogContent {
    constructor(viewContainerRef) {
      this.viewContainerRef = viewContainerRef;
    }
    static {
      this.ɵfac = function DynamicDialogContent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicDialogContent)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: DynamicDialogContent,
        selectors: [["", "pDynamicDialogContent", ""]],
        hostAttrs: [1, "p-element"]
      });
    }
  }
  return DynamicDialogContent;
})();